/**
 * @fileoverview Utilitários para formatação e cálculo de preços.
 * Garante consistência no tratamento de valores monetários em toda a aplicação.
 * 
 * @module PriceUtils
 * @since 1.0.0
 */

/**
 * Converte um valor para número, garantindo que seja válido para cálculos.
 * @param {string|number} value - Valor a ser convertido
 * @returns {number} Valor numérico válido ou 0 se inválido
 */
export const parsePrice = (value) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Converte quantidade para número inteiro válido.
 * @param {string|number} value - Quantidade a ser convertida
 * @returns {number} Quantidade numérica válida ou 0 se inválida
 */
export const parseQuantity = (value) => {
  const parsed = parseInt(value);
  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Formata um valor monetário para exibição em Real brasileiro.
 * @param {string|number} value - Valor a ser formatado
 * @returns {string} Valor formatado como moeda brasileira
 */
export const formatPrice = (value) => {
  const numericValue = parsePrice(value);
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(numericValue);
};

/**
 * Calcula o subtotal de um item (preço × quantidade).
 * @param {string|number} price - Preço unitário
 * @param {string|number} quantity - Quantidade
 * @returns {number} Subtotal calculado
 */
export const calculateSubtotal = (price, quantity) => {
  return parsePrice(price) * parseQuantity(quantity);
};

/**
 * Calcula o total de uma lista de itens do carrinho.
 * @param {Array} cartItems - Array de itens do carrinho
 * @returns {number} Total calculado
 */
export const calculateCartTotal = (cartItems) => {
  // reduce: soma todos os subtotais dos itens do carrinho
  return cartItems.reduce((total, item) => {
    return total + calculateSubtotal(item.preco, item.quantity);
  }, 0);
};